import { useState, useEffect, useMemo } from "react";
import _ from "lodash";
import { patchInvestigation } from "../../../../../apis";
import { Box, Paper, Stack } from "@mui/material";
import {
  InvestigationAdvertisement,
  InvestigationSectionHeader,
  Separator,
} from "../components";
import { SingleScenario, SingleScenarioReport } from "./SingleScenario";
import { AddAndEditScenario } from "./AddScenario";
import { useConstants } from "../Main/useConstants";
import { useTranslation } from "react-i18next";
import { useReport } from "../../../../../context/report/ReportContext";

export const Scenarios = ({
  reportDetail,
  investigation,
  setInvestigation,
  justView,
  handleSelectedSection,
  openConfirmDeleteModal,
  closeModalConfirm,
}) => {
  const [t] = useTranslation("investigation");
  const { enums } = useConstants();
  const { state } = useReport();
  const { relativeFields } = state;
  // const { relativeFields } = useSelector((state) => state.jaguar.currentReport);

  const [scenarios, setScenarios] = useState(investigation.scenarios ?? []);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedScenario, setSelectedScenario] = useState(null);

  const scenarioFromReport = useMemo(() => {
    const location = reportDetail?.stepers?.[1]?.form ?? null;
    return location;
    // return location;
    // const allAddress = [];
    // if (relativeFields.street) allAddress.push(relativeFields.street);
    // if (relativeFields.location) allAddress.push(relativeFields.location);
    // if (relativeFields.address) allAddress.push(relativeFields.address);
    // return allAddress.length > 0 ? allAddress.join(", ") : "";
  }, [relativeFields, reportDetail]);

  const someScenarioExist = useMemo(() => {
    if (scenarioFromReport) return true;
    if (scenarios.length > 0) return true;
    return false;
  }, [scenarios, scenarioFromReport]);

  useEffect(() => {
    if (investigation.scenarios !== null) {
      setScenarios(investigation.scenarios);
    } else {
      setScenarios([]);
    }
  }, [investigation?.scenarios]);

  const handleSaveScenarios = async (newScenarios) => {
    const objToSave = {
      folder: {
        scenarios: newScenarios,
      },
    };

    try {
      await patchInvestigation(investigation.alias, objToSave);
      setInvestigation({ ...investigation, scenarios: newScenarios });
      setSelectedScenario(null);
      setIsEditing(false);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Paper elevation={0} sx={{ p: 1}}>
      {!isEditing && !justView && (
        <InvestigationSectionHeader
          text={t("locations.add_location")}
          buttonIcon="outline_location_add"
          buttonText={t("locations.new_location")}
          onClick={() => setIsEditing(true)}
          type="scenarios"
        />
      )}

      {justView && (
        <Separator
          text={t("sections.locations")}
          icon="outline_map_3"
          iconButton={handleSelectedSection ? "outline_edit" : undefined}
          onClick={
            handleSelectedSection
              ? () => handleSelectedSection(enums.sections.scenarios)
              : undefined
          }
          sx={{ mb: 1.5 }}
        />
      )}

      {!someScenarioExist && !isEditing && (
        <InvestigationAdvertisement
          title={t("locations.no_locations_loaded")}
          description={t("locations.you_can_include_locations")}
        />
      )}

      {someScenarioExist && !isEditing && (
        <Stack spacing={2}>
          {Array.isArray(scenarioFromReport) && (
            <SingleScenarioReport scenario={scenarioFromReport} />
          )}

          {scenarios.length > 0 && (
            <>
              <Separator text={t("locations.additional_locations")} />
              <Stack spacing={2}>
                {scenarios.map((scenario, idx) => (
                  <SingleScenario
                    key={idx}
                    idx={idx}
                    scenario={scenario}
                    scenarios={scenarios}
                    handleSaveScenarios={handleSaveScenarios}
                    setSelectedScenario={setSelectedScenario}
                    setIsEditing={setIsEditing}
                    justView={justView}
                    openConfirmDeleteModal={openConfirmDeleteModal}
                    closeModalConfirm={closeModalConfirm}
                  />
                ))}
              </Stack>
            </>
          )}
        </Stack>
      )}

      {isEditing && (
        <AddAndEditScenario
          scenarios={scenarios}
          selectedScenario={selectedScenario}
          setSelectedScenario={setSelectedScenario}
          setIsEditing={setIsEditing}
          handleSaveScenarios={handleSaveScenarios}
        />
      )}
    </Paper>
  );
};
